// eslint-disable-next-line import/no-cycle
import APP_ERROR_CODES from '@/assets/data/errorCodes';
import router from '@/router/index';
import { useErrorStore } from '@/stores/components/errorStore';
import { logError } from '@/composables/tracking/useGoogleAnalyticTracking';

export default () => {
  function storeErrorInStore(errorCode, errorMessage, traceId) {
    const errorStore = useErrorStore();
    errorStore.setError({
      code: errorCode,
      message: errorMessage,
      traceId,
    });
  }

  function getTraceIdFromHeaders(headers) {
    const traceIdKey = Object.keys(headers).find((key) => key.toLowerCase() === 'x-tts-trace-id');
    return traceIdKey ? headers[traceIdKey] : null;
  }

  function handleServerErrors(error) {
    const defaultErrorCode = 'UNKNOWN_ERROR';
    const defaultErrorMsg = 'An unexpected error occurred';
    const responseData = error?.response?.data;
    const headers = error?.response?.headers || {};
    const errorCode = responseData?.code || defaultErrorCode;
    const errorMsg = responseData?.message || defaultErrorMsg;
    const traceId = getTraceIdFromHeaders(headers);

    logError({
      type: 'API', errorCode, errorMsg, traceId,
    });

    storeErrorInStore(errorCode, errorMsg, traceId);

    router.push({
      name: 'error',
      params: { errorCode },
    });
  }

  function handleMappedErrorResponses(code) {
    const { field, error, callback } = APP_ERROR_CODES.get(code) || {};
    if (callback) {
      callback();
    }

    return field || error ? { field, error } : null;
  }

  function handleErrorInSpaFlow(errorCode, message, traceId) {
    storeErrorInStore(errorCode, message, traceId);

    logError({
      type: 'APP', code: errorCode, message, traceId,
    });

    router.push({
      name: 'error',
      params: {
        errorCode,
      },
    });
  }

  return {
    handleServerErrors,
    handleMappedErrorResponses,
    handleErrorInSpaFlow,
    getTraceIdFromHeaders,
  };
};
